import { PageLayout } from "@components/ui/PageLayout"
import { createFileRoute } from "@tanstack/react-router"
import { ErrorPage } from "./-ErrorPage"

export const Route = createFileRoute("/404")({
  component: () => (
    <PageLayout page="error404">
      <ErrorPage />
    </PageLayout>
  ),
})
